import type { Scan } from "@hobbyshopify/backend-client";
import { Link } from "react-router-dom";

export function UnrecognisedScan({
  scan,
  onNewScan,
  uploadLink = false,
}: {
  scan: Scan;
  onNewScan?: () => void;
  uploadLink?: boolean;
}) {
  return (
    <div className="flex flex-col items-start gap-4 sm:flex-row border-b border-line py-4" role="status">
      <div className="flex gap-2">
        {[scan.imageUrl, scan.backImageUrl]
          .filter((url): url is string => Boolean(url))
          .map((url, i) => (
            <img
              key={url}
              src={url}
              alt={`Unrecognised card ${i === 0 ? "front" : "back"}`}
              className="h-28 w-20 rounded-thumb bg-surface object-contain"
            />
          ))}
      </div>
      <div className="min-w-0 flex-1 space-y-2">
        <p className="text-sm font-semibold text-white">Card could not be recognised</p>
        <p className="text-sm text-muted">Upload a new photo with the whole card in frame and even lighting.</p>
        <p className="text-xs text-muted">{scan.createdAt.toLocaleString()}</p>
        {onNewScan && (
          <button type="button" className="btn-primary btn-sm" onClick={onNewScan}>
            Upload a new card image
          </button>
        )}
        {uploadLink && (
          <Link to="/scan" className="btn-primary btn-sm inline-flex">
            Upload a new card image
          </Link>
        )}
      </div>
    </div>
  );
}
